import { useEffect, useMemo, useRef, useState } from "react";

import "./index.scss";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../store/store";
import {
    addPDMCurriculamTimeline,
  addPDMSummit,
  getPDMCurriculamTimeline,
  getPDMSummit,
} from "../../../store/features/AdminPanel/Setting/ProductPageSubtitles/ProductPageSubtitesAPi";
import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";
import ProductPageSubtitlesTab from "./ProductPageSubtitlesTab";

const ProductPageSubtitlesPage = () => {

  const dispatch = useAppDispatch();
  const [content, setContent] = useState("");
  const [pdmCurriculamTimelineContent,setCurriculamTimeLineContent] = useState("")


  const ProductPageSubtitlesState: any = useAppSelector((store: RootStore) => {
    return store.ProductPageSubtitlesSlice;
  });
  const themeState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });


  function sanitizeContent(content:string) {
    if (!content || content.trim() === "" || content.trim() === "<p><br></p>") {
      return null;
    }
    return content;
  }
  
  useEffect(() => {
    dispatch(getPDMSummit());
    dispatch(getPDMCurriculamTimeline());
  }, []);

  useEffect(() => {
    if (ProductPageSubtitlesState.req_success.add_summit) {
      setContent(ProductPageSubtitlesState?.pdm_summit?.content);
    }
  }, [ProductPageSubtitlesState.req_success.add_summit]);
  useEffect(() => {
    if (ProductPageSubtitlesState.req_success.add_timeline) {
        setCurriculamTimeLineContent(ProductPageSubtitlesState?.pdm_timeline?.content);
    }
  }, [ProductPageSubtitlesState.req_success.add_timeline]);

  return (
    <AdminPanelLayout>
      <ProductPageSubtitlesTab/>
    </AdminPanelLayout>
  );
};

export default ProductPageSubtitlesPage;
